const createAlertDom = (message, type = 'success') => {
    const html = '<div class="c-head-alert"><p class="c-head-alert__text"></p>';
    const div = document.createElement('div');
    div.innerHTML = html;
    const alertDom = div.firstChild;
    alertDom.querySelector('.c-head-alert__text').textContent = message;
    alertDom.classList.add('alert-' + type);
    setAction(alertDom);

    return alertDom;
}

const setAction = (alertDom) => {
    setTimeout(() => {
        alertDom.classList.add('is-fade');
    }, 3000);
    alertDom.addEventListener("transitionend", (event) => {
        alertDom.remove();
    });
    alertDom.addEventListener('click', (e) => {
        e.currentTarget.remove();
    });
}

export const setAlert = (message, type = 'success') => {
    const alertDom = createAlertDom(message, type);
    document.querySelector('body').appendChild(alertDom);
}

const main = () => {
    const alertDom = document.querySelector('.c-others-head-alert');
    if(alertDom){
        setAction(alertDom);
    }
}

export default main;
